<fas-services-table class="table-height" scrollHeight="flex"
  [value]="topicsContentList"
  [rows]="currentRows"
  [columns]="topicColumns"
  [rowsPerPageOptions]="[10, 25, 50, 100]"
  [first]="currentFirst"
  [paginator]="true"
  [showCheckbox]="false"
  [loading]="isLoading"
  (pageChange)="setCurrentPosition($event)"
  [showCurrentPageReport]="true"
  [showFooterPageReport]="false"
  [isOutlineHeadlight]="true"
  [showSearch]="true"
  searchPlaceholder="Szukaj slajdu..."
  [dropdownFilters]="dropdownFilters"
  (filtersChange)="onFiltersChange($event)"
  [rowClickFunction]="onRowTap"
  >
  <ng-template #slideImage let-rowData>
    <img *ngIf="rowData.imageLink" [src]="getSlideImageUrl(rowData.imageLink)" alt="" class="slide-thumbnail" />
  </ng-template>
</fas-services-table>

<app-content-details
  [(detailsControl)]="detailsControl"
  [topic]="selectedTopicContent"
  [topicList]="originalTopicsContentList"
  [topicIndex]="topicIndex"
  (refreshTopics)="refreshTopics()">
</app-content-details>
